import { useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ScanText } from "lucide-react";
import { SavedReports, AuditHistory } from "@/components/verification/History";
import { SessionsList } from "@/components/verification/SessionsList";
import { SessionView } from "@/components/verification/SessionView";

export default function BookVerification() {
  const { sessionId } = useParams();
  const [tab, setTab] = useState("sessions");
  return (
    <div data-testid="book-verification-page" className="space-y-5">
      <div>
        <h1 className="font-chivo font-black text-2xl sm:text-3xl text-slate-900 flex items-center gap-2"><ScanText className="h-7 w-7 text-sky-600" /> Book Verification</h1>
        <p className="text-slate-500 mt-1 text-sm sm:text-base">Everything is saved on the server — continue on any device. Website sales change only when you approve a correction.</p>
      </div>
      {sessionId ? <SessionView key={sessionId} sessionId={sessionId} /> : (
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="flex-wrap h-auto max-w-full">
            <TabsTrigger value="sessions" data-testid="tab-sessions">Verifications</TabsTrigger>
            <TabsTrigger value="saved" data-testid="tab-saved-reports">Saved Reports</TabsTrigger>
            <TabsTrigger value="audit" data-testid="tab-audit-history">Website Edit History</TabsTrigger>
          </TabsList>
          <TabsContent value="sessions" className="mt-4">{tab === "sessions" && <SessionsList />}</TabsContent>
          <TabsContent value="saved" className="mt-4">{tab === "saved" && <SavedReports />}</TabsContent>
          <TabsContent value="audit" className="mt-4">{tab === "audit" && <AuditHistory />}</TabsContent>
        </Tabs>
      )}
    </div>
  );
}
